import { createCollection, type Collection } from '@tanstack/react-db';
import { queryCollectionOptions } from '@tanstack/query-db-collection';
import type { QueryClient } from '@tanstack/react-query';
import { fetchCompanies } from './api';
import type { Company } from '@repo/database/browser';

/**
 * Creates a collection for companies with TanStack Query integration.
 *
 * Note: Type assertion is needed due to a mismatch between queryCollectionOptions
 * returning key type `string` and createCollection expecting `string | number`.
 * This is a known limitation in TanStack DB beta.
 * See: https://github.com/TanStack/db/issues/675
 */
export const createCompanyCollection = (
  tenantId: string,
  queryClient: QueryClient
): Collection<Company> =>
  createCollection<Company>(
    queryCollectionOptions({
      queryKey: ['company', 'list', tenantId, {}],
      queryFn: async () => {
        const response = await fetchCompanies(tenantId, {});
        return response.data;
      },
      queryClient,
      getKey: (item) => item.id,
      staleTime: Infinity, // Master data - only invalidated by mutations
    }) as never
  );

export type CompanyCollection = Collection<Company>;
